import {
  ButtonColors,
  ButtonSizes,
  ButtonVariants,
  Card,
  DesignButton,
  ImageFallback,
} from 'components';
import { Typography } from '@repo/ui';
import guidePlaceholder from 'assets/images/placeholders/book.svg';
import Guide from 'types/Guide';

import styles from './GuideCard.module.css';

export const GuideCard = ({ guide }: { guide: Guide }) => {
  return (
    <Card
      variant='wrapper'
      clickable={
        !guide?.url
          ? undefined
          : {
              text: 'Guide: ' + guide.display_title,
              href: guide.url,
              variety: 'Card',
              isExternal: true,
            }
      }
    >
      <div className={styles.guideCard}>
        <div className={styles.content}>
          <div className={styles.imgContainer}>
            <ImageFallback src={guide.image_url} fallback={guidePlaceholder} />
          </div>
          <Typography variant='heading-m'>{guide.display_title}</Typography>
          <div className={styles.twoLinesOfText}>
            <Typography variant='paragraph' className='grey-text'>
              {guide.description}
            </Typography>
          </div>
        </div>
        <DesignButton
          label='Read more'
          variant={ButtonVariants.TEXT}
          size={ButtonSizes.M}
          color={ButtonColors.PURPLE}
        />
      </div>
    </Card>
  );
};
